import { colors } from '@spritz-finance/ui'
import styled from 'styled-components'

export const GoogleButtonComponent = styled.button`
    width: 100%;
    max-width: 343px;
    border-radius: 25px;
    height: 48px;
    font-family: inherit;
    font-size: 14px;
    line-height: 17px;
    font-style: normal;
    font-weight: 500;
    border: 1px solid ${colors.black};
    background-color: var(--color-brand, ${colors.white});
    color: var(--text-primary, ${colors.black});
    &:hover {
        cursor: pointer;
        filter: brightness(97%);
    }
    &:active {
        filter: brightness(92%);
    }
    @media screen and (max-height: 750px) {
        height: 39.5px;
    }
`
export const GoogleButtonTextContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-height: 750px) {
        height: 34.5px;
    }
`

export const GoogleButtonText = styled.div`
    display: flex;
    align-items: center;
    margin-left: 10px;
`
